{
  "accountActions": {
    "error": "エラーが発生しました"
  },
  "aiDetectionLlmPayload": {
    "text": "検知対象: {{goal}}",
    "text2": "検知条件: {{condition}}"
  },
  "aiDetectionObservationsQuery": {
    "error": "AI検知観測の{{field}}が不正です",
    "error2": "AI検知観測がオブジェクトではありません",
    "error3": "AI検知観測の必須項目がありません",
    "error4": "AI検知観測のobservedAtが不正です",
    "error5": "AI検知観測のtenantCameraIdが不正です",
    "error6": "AI検知観測のvalidationが不正です",
    "error7": "採用されたAI検知観測に拒否理由があります",
    "error8": "拒否されたAI検知観測に理由がありません",
    "error9": "AI検知観測のconfidenceが範囲外です",
    "error10": "AI検知観測のvalidationとvalueが矛盾しています",
    "error11": "AI検知観測のunitが不正です",
    "error12": "AI検知観測の取得期間は最大24時間です",
    "error13": "AI検知観測の取得件数が不正です",
    "error14": "AI検知観測の並び順が不正です",
    "error15": "AI検知観測のcursorが不正です",
    "error16": "AI検知観測レスポンスが不正です",
    "error17": "AI検知観測レスポンスのnextCursorが不正です",
    "error18": "AI検知観測の走査を中断しました",
    "error19": "AI検知観測のページカーソルが重複しました"
  },
  "aiDetectionReviews": {
    "error": "AI検知レビューのレスポンスが不正です",
    "text": "レビュー内容が競合しました"
  },
  "aiDetectionsQuery": {
    "text": "人数: {{value}}",
    "text2": "値: {{value}}{{unit}}",
    "text3": "値: {{value}}",
    "text4": "人数: {{personCount}}",
    "error": "AI検知イベントの走査を中断しました",
    "error2": "AI検知イベントのページカーソルが重複しました"
  },
  "cameraMutations": {
    "text": "AI検知の状態確認に失敗したため、エリア移動を中止しました。",
    "error": "有効なAI検知があります。AI検知を停止させてからエリア移動を行ってください。"
  },
  "recorderSubsystem": {
    "error": "プリセット一覧のパースに失敗しました"
  },
  "samlMutation": {
    "text": "SAMLの設定が完了していません。所属する組織の全体管理者にご確認ください",
    "error": "テナント名が指定されていません",
    "error2": "SAML レスポンスの形式が不正です"
  },
  "tenantSamlMutation": {
    "text": "バリデーションエラーが発生しました",
    "error": "テナント設定のレスポンス形式が不正です",
    "error2": "tenantConfiguration が含まれていません"
  },
  "thumbnailsQuery": {
    "error": "tenantId と cameraId は必須です"
  },
  "userMultipleInviteMutation": {
    "text": "送信に失敗しました"
  },
  "login": {
    "text": "半角の英大文字、英小文字、数字、記号をすべて含む、8〜256文字で設定してください。",
    "text3": "パスワードもしくはメールアドレスが間違っています、再度入力してください",
    "text6": "ログイン中にエラーが発生しました: {{value}}",
    "error": "新しいパスワードが必要です",
    "text7": "新しいパスワードの設定中にエラーが発生しました: {{value}}",
    "expired": "ログインの有効期限が切れました。もう一度ログインしてください。"
  },
  "mfa": {
    "message": "確認コードの入力回数が上限に達しました。しばらくしてから再度ログインしてください。",
    "message3": "エラーが発生しました"
  },
  "passwordPolicy": {
    "passwordPolicyError": "半角の英大文字、英小文字、数字、記号をすべて含む、8〜256文字で設定してください。"
  },
  "useNotFoundRedirect": {
    "enqueueSnackbar": "存在しないページです"
  },
  "accountMenu": {
    "text": "ヘルプセンター",
    "ariaLabel": "アカウントメニューを開く",
    "title": "アカウント設定",
    "title2": "企業設定",
    "menuItem": "プライバシーポリシー",
    "menuItem2": "利用規約",
    "text2": "公式アプリ",
    "menuItem3": "ログアウト",
    "language": "言語"
  },
  "calendarDateTimePicker": {
    "text": "日",
    "text2": "月",
    "text3": "火",
    "text4": "水",
    "text5": "木",
    "text6": "金",
    "text7": "土",
    "ariaLabel": "前日",
    "ariaLabel2": "日時を選択: {{displayDateTime}}",
    "ariaLabel3": "翌日",
    "ariaLabel4": "時刻",
    "ariaLabel5": "設定した日時へ移動"
  },
  "row": {
    "text": "折りたたむ",
    "text2": "展開する"
  },
  "dialog": {
    "ariaLabel": "ダイアログを閉じる"
  },
  "documentLayout": {
    "link": "ログイン",
    "link2": "ヘルプセンター",
    "link3": "利用規約",
    "link4": "プライバシーポリシー",
    "link5": "運営会社"
  },
  "emailListInput": {
    "text": "メールアドレス",
    "text2": "追加する",
    "text3": "メールアドレス欄を削除"
  },
  "header": {
    "text": "映像一覧"
  },
  "imagePreviewDialog": {
    "text": "ダウンロード中...",
    "text2": "ダウンロード",
    "text3": "画像を表示できませんでした",
    "text4": "ダウンロードに失敗しました"
  },
  "search": {
    "text": "カメラ名・エリア名・タグで検索"
  },
  "multiSelect": {
    "text": "テキスト",
    "text2": "{{length}}件選択中"
  },
  "nestedMultiSelect": {
    "text": "エリア・デバイス閲覧権限",
    "text2": "{{length}}件選択中"
  },
  "select": {
    "text": "テキスト"
  },
  "sidebar": {
    "label": "映像一覧",
    "label2": "キャプチャ一覧",
    "label3": "ユーザー管理",
    "label4": "カメラ管理",
    "label5": "エリア管理",
    "label6": "タグ管理",
    "label7": "ライセンス",
    "label8": "パトライト管理",
    "label9": "ファームウェア管理",
    "label10": "マップ管理",
    "replace": "\n管理"
  },
  "simplePagination": {
    "text": "{{value}}件以上",
    "text2": "{{value}}件",
    "text3": "{{value}}-{{value2}}/{{value3}}件以上",
    "text4": "{{value}}-{{value2}}/{{value3}}件"
  },
  "assertNever": {
    "error": "{{context}}: 未対応の値 {{value}}"
  },
  "emailValidation": {
    "emailValidationMessage": "正しいメールアドレスを入力してください"
  },
  "tenant": {
    "label": "取扱説明書",
    "label2": "ヘルプセンター"
  },
  "aiDetectionCsvExportLimit": {
    "error": "CSV出力を中断しました",
    "error2": "CSV出力の走査上限に達しました。期間を短くして再度お試しください。CSVは出力していません。",
    "error3": "CSV出力上限（{{value}}行）を超えています。期間や絞り込み条件を変更してください。CSVは出力していません。"
  },
  "meterReadingResults": {
    "text": "読取不採用",
    "error": "メーター履歴のカーソルが不正です"
  },
  "useMeterReadingPreviews": {
    "error": "テナントを確認できません",
    "text": "読取結果を取得できません",
    "text2": "読取結果を取得中",
    "text3": "直近24時間の読取はありません。詳細で期間を指定できます。"
  },
  "detectionConditionField": {
    "label": "検知条件"
  },
  "roleLabel": {
    "sv": "全体管理者",
    "areaManager": "エリア管理者",
    "operator": "オペレーター",
    "viewer": "閲覧者"
  }
}
